var map = {
	"./Interfaz_estudio.mp4": 2308,
	"./JorgeValdiviaPerdomo.jpg": 5771,
	"./LoannaPereiraOliver.jpg": 6614,
	"./MartinBonillaBernadet.jpg": 6435,
	"./SantiagoCaballeroCabrera.jpg": 2481,
	"./VictoriaCirilloChiarle.jpg": 6313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6598;